import { pBase } from './.catalog';

export default class pOtpAl extends pBase {
  constructor(options: { KullaniciAdi?: string; Telefon?: string; YeniSifre?: string }) {
    super();
    this.KullaniciAdi = options.KullaniciAdi;
    this.Telefon = options.Telefon;
    this.YeniSifre = options.YeniSifre;
  }
  public KullaniciAdi: string | undefined;
  public Telefon: string | undefined;
  public YeniSifre: string | undefined;
}
